import { Grid } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';

import Body from './components/Body';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import { TEMPLATE_AREA, TEMPLATE_AREA_WITH_SIDEBAR } from './constants';

interface PreviewLayoutParts {
  Topbar: typeof Topbar;
  Sidebar: typeof Sidebar;
  Body: typeof Body;
}

interface PreviewLayoutProps {
  withSidebar?: boolean;
}

const PreviewLayout: FCWithChildren<PreviewLayoutProps> &
  PreviewLayoutParts = ({ children, withSidebar }) => (
  <Grid
    height="100vh"
    templateAreas={withSidebar ? TEMPLATE_AREA_WITH_SIDEBAR : TEMPLATE_AREA}
    templateColumns={withSidebar ? '1fr 360px' : '1fr'}
    templateRows="66px 1fr"
  >
    {children}
  </Grid>
);

PreviewLayout.Topbar = Topbar;
PreviewLayout.Sidebar = Sidebar;
PreviewLayout.Body = Body;

export default PreviewLayout;
